(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["application-form-section"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener("DOMContentLoaded", () => {

        gsap.registerPlugin(ScrollTrigger);

        const animation = () => {

            let tl = gsap.timeline();

            tl.fromTo(".application-form-section", {
                scale: 0.8,
             
                transformOrigin: "bottom center",
                borderRadius: "15px"
            }, {
                scale: 1,
                borderBottomLeftRadius: "0px",
                borderBottomRightRadius: "0px",
             
            });

            return tl
            
        }

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".application-form-section--gsap",
                start: "top-=25% top+=25%",
                end: "top bottom-=25%",
                toggleActions: "restart none none reverse",
                pin: ".application-form-section--gsap",
                pinSpacing: true,
                markers: false
            }
        });

        tl.add(animation())



    })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestsellers-section"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener('DOMContentLoaded', () => {

        const carousels = document.querySelectorAll('.bestsellers-section .swiper');

        carousels.forEach(carousel => {
            const swiper = new Swiper(carousel, {
                slidesPerView: 1.1,
                spaceBetween: 24,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                    1440: {
                        slidesPerView: 4,
                    }
                },
                mousewheel: {
                    forceToAxis: true
                },
                observer: true,  
                observeParents: true,
            });
        });

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["browse-by-section"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener('DOMContentLoaded', () => {

        const carousels = document.querySelectorAll('.browse-by-section .swiper');

        carousels.forEach(carousel => {
            const swiper = new Swiper(carousel, {
                slidesPerView: 1.1,
                spaceBetween: 24,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                    1440: {
                        slidesPerView: 4,
                    }
                },
                mousewheel: {
                    forceToAxis: true
                },
                observer: true,  
                observeParents: true,
            });
        });

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
      

document.addEventListener('DOMContentLoaded', () => {
  const toggleButtons = document.querySelectorAll('footer button.toggle');
  const lists = document.querySelectorAll('footer button.toggle + ul');

  toggleButtons.forEach(button => {
    button.addEventListener('click', () => {
      const ul = button.nextElementSibling;

      // If the button is already active, deactivate it and its list
      if (button.classList.contains('is-active')) {
        button.classList.remove('is-active');
        ul.classList.remove('is-active');
        return;
      }

      // Otherwise, deactivate all buttons and lists, then activate the clicked one
      toggleButtons.forEach(btn => btn.classList.remove('is-active'));
      lists.forEach(list => list.classList.remove('is-active'));

      button.classList.add('is-active');
      ul.classList.add('is-active');
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jump-to-section"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener('DOMContentLoaded', () => {

        const buttons = document.querySelectorAll('.jump-to');

        buttons.forEach(button => {
            button.addEventListener('click', () => {
       
                const parentSection = button.closest('[id^="shopify-section-"]').parentElement;
                console.log(parentSection)

                if (!parentSection) return;
                
                let nextSibling = parentSection.nextElementSibling;
                console.log(nextSibling)

                while (nextSibling && !nextSibling.id.startsWith('shopify-section-')) {
                    nextSibling = nextSibling.nextElementSibling;
                }

                if (nextSibling) {
                    const element = nextSibling;
                    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;

                    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = elementPosition - headerHeight;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth',
                    });
                }

            });
        });

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-section"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener('DOMContentLoaded', () => {

        const carousels = document.querySelectorAll('.recently-section .swiper');

        carousels.forEach(carousel => {
            const swiper = new Swiper(carousel, {
                slidesPerView: 1.1,
                spaceBetween: 24,
                breakpoints: {
                    840: {
                        slidesPerView: 2,
                    },
                    1140: {
                        slidesPerView: 3,
                    },
                    1440: {
                        slidesPerView: 4,
                    },
                    1800: {
                        slidesPerView: 5,
                    }
                },
                mousewheel: {
                    forceToAxis: true
                },
                observer: true,  
                observeParents: true,
            });
        });

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-section"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener('DOMContentLoaded', () => {

        const carousels = document.querySelectorAll('.shop-by-section .swiper');

        carousels.forEach(carousel => {
            const swiper = new Swiper(carousel, {
                loop: true,
                centeredSlides: true,
                slidesPerView: 1,
                spaceBetween: 24,
                breakpoints: {
                    768: {
                        slidesPerView: 1,
                    },
                    1024: {
                        slidesPerView: 1,
                    },
                    1440: {
                        slidesPerView: 1,
                    }
                },
                mousewheel: {
                    forceToAxis: true
                },
                observer: true,  
                observeParents: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '">' + (index + 1) + "</span>";
                    },
                },
            });
        });

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-section"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener('DOMContentLoaded', () => {
        
        const container = document.querySelector('.testimonial-section .page-width .columns');

        if (container) {

            const updateContainerWidth = () => {
                const width = container.offsetWidth;
                document.documentElement.style.setProperty('--ts-pageWidth', `${width}px`);
            };

            updateContainerWidth();

            const resizeObserver = new ResizeObserver(() => {
                updateContainerWidth();
            });

            resizeObserver.observe(container);

            window.addEventListener('beforeunload', () => {
                resizeObserver.disconnect();
            });

        }

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trusted-by-section"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener('DOMContentLoaded', () => {

        const carousels = document.querySelectorAll('.trusted-by-section .swiper');

        carousels.forEach(carousel => {
            const swiper = new Swiper(carousel, {
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                loop: true,
                slidesPerView: 3,
                spaceBetween: 24,
                breakpoints: {
                    768: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 5,
                    },
                    1440: {
                        slidesPerView: 6,
                    }
                },
                mousewheel: {
                    forceToAxis: true
                },
                observer: true,  
                observeParents: true,
            });
        });

    });


  } catch(e) { console.error(e); }
})();
})();
